














import Vue from 'vue';

const ratingColor = (status: string): string => {
  const mappings: { [status: string]: string } = {
    high: 'danger',
    medium: 'warning',
    low: 'success',
    critical: 'dark',
  };

  const color = status ? mappings[status.toLowerCase()] : null;
  return `badge badge-outline badge-outline-${color || 'primary'}`;
};

export default Vue.extend({
  name: 'RatingCellPresenter',
  filters: {
    ratingColor,
  },
});
